import { call, put, takeEvery } from "redux-saga/effects";
import { quyetDinhChuyenLopApi, stuTrangThaiHocKyApi } from "../../../api/phan-lop-chuyen-nganh/phanLopChuyenNganhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  IChotDuLieuRequest,
  IChuyenLopChiTietRequest,
  IChuyenLopSinhViensRequest,
  IQuyetDinhChuyenLop,
  IQuyetDinhChuyenLopFilterRequest,
  ITrangThaiHocKyFilterRequest,
} from "../../../model/respone/phan-lop-chuyen-nganh/IPhanLopChuyenNganh";
import {
  ePhanLopChuyenNganhActionIds,
  IPhanLopChuyenNganhActionTypes,
} from "../../action-types/phan-lop-chuyen-nganh/IPhanLopChuyenNganhActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.phanLopChuyenNganh.phanLopChuyenNganh;

export function* phanLopChuyenNganhSaga(): any {
  yield takeEvery(ePhanLopChuyenNganhActionIds.LOAD_TRANG_THAIS_START, loadTrangThaisWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.CHOT_START, chotWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.SET_LOCK_START, setLockWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.DELETE_CHOTS_START, deleteChotsWorker);

  yield takeEvery(ePhanLopChuyenNganhActionIds.LOAD_QUYET_DINHS_START, loadQuyetDinhsWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.SAVE_QUYET_DINH_START, saveQuyetDinhWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.DELETE_QUYET_DINH_START, deleteQuyetDinhWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.LOAD_CHI_TIETS_START, loadChiTietsWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.ADD_CHI_TIETS_START, addChiTietsWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.UPDATE_LOP_MOI_START, updateLopMoiWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.CHUYEN_LOP_START, chuyenLopWorker);
  yield takeEvery(ePhanLopChuyenNganhActionIds.THU_HOI_START, thuHoiWorker);
}

function* loadTrangThaisWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const filter = action.payload as ITrangThaiHocKyFilterRequest;
  if (!filter?.nam_hoc) {
    yield put(mainAction.LOAD_TRANG_THAIS_SUCCESS([]));
    return;
  }
  const res: IBaseRespone = yield call(stuTrangThaiHocKyApi.SelectByPhamVi, filter);
  if (res.is_success) yield put(mainAction.LOAD_TRANG_THAIS_SUCCESS(res.data));
  else yield put(mainAction.LOAD_TRANG_THAIS_ERRR(res.message ?? "Có lỗi"));
}

function* chotWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(stuTrangThaiHocKyApi.Chot, action.payload as IChotDuLieuRequest);
  if (res.is_success) yield put(mainAction.CHOT_SUCCESS(res.data));
  else yield put(mainAction.CHOT_ERRR(res.message ?? "Có lỗi"));
}

function* setLockWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const { ids, is_locked } = action.payload as { ids: number[]; is_locked: boolean };
  const res: IBaseRespone = yield call(stuTrangThaiHocKyApi.SetLock, ids, is_locked);
  if (res.is_success) yield put(mainAction.SET_LOCK_SUCCESS(res.data));
  else yield put(mainAction.SET_LOCK_ERRR(res.message ?? "Có lỗi"));
}

function* deleteChotsWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(stuTrangThaiHocKyApi.Deletes, action.payload as number[]);
  if (res.is_success) yield put(mainAction.DELETE_CHOTS_SUCCESS(res.data));
  else yield put(mainAction.DELETE_CHOTS_ERRR(res.message ?? "Có lỗi"));
}

function* loadQuyetDinhsWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const filter = action.payload as IQuyetDinhChuyenLopFilterRequest;
  if (!filter?.nam_hoc) {
    yield put(mainAction.LOAD_QUYET_DINHS_SUCCESS([]));
    return;
  }
  const res: IBaseRespone = yield call(quyetDinhChuyenLopApi.SelectByKy, filter);
  if (res.is_success) yield put(mainAction.LOAD_QUYET_DINHS_SUCCESS(res.data));
  else yield put(mainAction.LOAD_QUYET_DINHS_ERRR(res.message ?? "Có lỗi"));
}

function* saveQuyetDinhWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const payload = action.payload as IQuyetDinhChuyenLop;
  const res: IBaseRespone =
    payload.id_qd > 0
      ? yield call(quyetDinhChuyenLopApi.Update, payload)
      : yield call(quyetDinhChuyenLopApi.Insert, payload);
  if (res.is_success) yield put(mainAction.SAVE_QUYET_DINH_SUCCESS(res.data));
  else yield put(mainAction.SAVE_QUYET_DINH_ERRR(res.message ?? "Có lỗi"));
}

function* deleteQuyetDinhWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(quyetDinhChuyenLopApi.Delete, action.payload as number);
  if (res.is_success) yield put(mainAction.DELETE_QUYET_DINH_SUCCESS(res.data));
  else yield put(mainAction.DELETE_QUYET_DINH_ERRR(res.message ?? "Có lỗi"));
}

function* loadChiTietsWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const idQd = action.payload as number;
  if (!idQd) {
    yield put(mainAction.LOAD_CHI_TIETS_SUCCESS([]));
    return;
  }
  const res: IBaseRespone = yield call(quyetDinhChuyenLopApi.SelectChiTiet, idQd);
  if (res.is_success) yield put(mainAction.LOAD_CHI_TIETS_SUCCESS(res.data));
  else yield put(mainAction.LOAD_CHI_TIETS_ERRR(res.message ?? "Có lỗi"));
}

function* addChiTietsWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(quyetDinhChuyenLopApi.AddChiTiets, action.payload as IChuyenLopChiTietRequest);
  if (res.is_success) yield put(mainAction.ADD_CHI_TIETS_SUCCESS(res.data));
  else yield put(mainAction.ADD_CHI_TIETS_ERRR(res.message ?? "Có lỗi"));
}

function* updateLopMoiWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(quyetDinhChuyenLopApi.UpdateLopMoi, action.payload as IChuyenLopChiTietRequest);
  if (res.is_success) yield put(mainAction.UPDATE_LOP_MOI_SUCCESS(res.data));
  else yield put(mainAction.UPDATE_LOP_MOI_ERRR(res.message ?? "Có lỗi"));
}

function* chuyenLopWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(quyetDinhChuyenLopApi.ChuyenLop, action.payload as IChuyenLopSinhViensRequest);
  if (res.is_success) yield put(mainAction.CHUYEN_LOP_SUCCESS(res.data));
  else yield put(mainAction.CHUYEN_LOP_ERRR(res.message ?? "Có lỗi"));
}

function* thuHoiWorker(action: IPhanLopChuyenNganhActionTypes): any {
  const res: IBaseRespone = yield call(quyetDinhChuyenLopApi.ThuHoi, action.payload as IChuyenLopSinhViensRequest);
  if (res.is_success) yield put(mainAction.THU_HOI_SUCCESS(res.data));
  else yield put(mainAction.THU_HOI_ERRR(res.message ?? "Có lỗi"));
}
